import { ReadonlyURLSearchParams } from 'next/navigation';

function getRichTextUrl(
  incomingUrl: string,
  newParams?: ReadonlyURLSearchParams,
  hostName?: string,
) {
  if (!newParams || !incomingUrl?.includes('checkout')) {
    return incomingUrl;
  }
  try {
    const url = new URL(incomingUrl);
    const targetUrl = new URL(`https://${hostName}`);
    if (url.hostname.includes(targetUrl.hostname)) {
      newParams.forEach((value, key) => {
        url.searchParams.append(key, value);
      });
    }
    return url.toString();
  } catch (error) {
    return incomingUrl;
  }
}

export default getRichTextUrl;
